/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'email-auth-big': {
    width: 16,
    height: 16,
    viewBox: '0 0 96 96',
    data: '<defs/><g id="复杂大型图标"><path pid="0" class="cls-1" d="M68.51 39.54L80 31.82V24L48 45 16 24v7.76l15.56 10.45L48 53l20.51-13.46z"/><path pid="1" class="cls-2" d="M16 24l32 21 32-21v7.82l8-5.37V16H8v10.38l8 5.38V24z"/><path pid="2" class="cls-3" d="M31.56 42.21L16 31.76l-8-5.38V80h.28l39.77-26.71-16.49-11.08z"/><path pid="3" class="cls-4" d="M80 31.82l-11.49 7.72-20.46 13.75L8.28 80H88V26.45l-8 5.37z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/email-auth-big.js